import { render, staticRenderFns } from "./DistributionBar.vue?vue&type=template&id=6a6ea20f&scoped=true"
import script from "./DistributionBar.vue?vue&type=script&lang=js"
export * from "./DistributionBar.vue?vue&type=script&lang=js"
import style0 from "./DistributionBar.vue?vue&type=style&index=0&id=6a6ea20f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ea20f",
  null
  
)

export default component.exports